const featureList = {
    FnB: [
        "CI.AE",
        // "CI.PRHM",
        "CI.GRM",
        "ZS.VN",
        "OCT.MBC",
        "OCT.KT",
        "TA.CCTV",
        "HI.FNB",
        "KHD.HWT",
        "KHD.FMM",
        "KPPE.HD",
        "KPPE.FMD",
        "KPPE.GD"
    ],
    Retail: [
        "CI.AE",
        // "CI.CCM",
        // "CI.PRHM",
        "CI.PC",
        "CI.EL",
        "CI.SH",
        "CI.GRM",
        "SAD.SD",
        "SEPM.SEU",
        "SEPM.PU",
        // "SEPM.OCT",
        // "HI.R",
        "EM.EWD",
        "ST.STP",
        "CS.SD",
        // "CS.PG",
        // "CS.SA",
        // "CS.MD"
    ],
    Workspace: [
        "WI.RO",
        // "SAD.VD",
        "TA.CCTV",
        "EM.EWD",
        "CS.SD",
        // "CS.SA",
        "CS.MD"
    ]
};

export default featureList;